import store from "../store";

export default async (to, from, next) => {
  //settings
  document.title = (to.meta.title || to.name) + " - Backoffice | Criptospace";
  if (to.name != from.name) window.scrollTo(0, 0);

  // handle auth and permission state
  const requiresAuth = to.meta.requiresAuth || false;
  const preventAuth = to.meta.preventAuth || false;
  const requiresPermission = to.meta.requiresPermission || false;
  const authenticated = store.getters.authenticated;

  // if the user has not authenticated and tries access private page
  if (requiresAuth && !authenticated) return next("/auth");

  // if the user has authenticated and tries access prevent authenticated page
  if (preventAuth && authenticated) return next("/");

  // checking access permission
  if (
    requiresPermission &&
    !store.getters.user.permissions.includes(requiresPermission)
  )
    next("/access-denied");

  // else... next
  next();
};
